import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          "https://mycobro.com/api/categories/all_stores"
        );
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    
    <section className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
       
        <h3 className="text-4xl font-bold text-center mb-12">
          Explore Categories from Top Stores
        </h3>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {categories.map((category) => (
            <div
              key={category._id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transform hover:-translate-y-1 transition-all"
            >
              {/* Optional: Category image placeholder */}
              <div className="h-48 bg-gradient-to-r from-blue-500 to-teal-500 flex items-center justify-center">
                <span className="text-white text-2xl font-bold uppercase">
                  {category.name.charAt(0)}
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-semibold text-gray-800 mb-1">
                  {category.name}
                </h3>
                <div className="text-sm text-gray-500 mb-4">
                  <p>
                    <span className="font-semibold">Store:</span>{" "}
                    {category.store?.name || "Unknown Store"}
                  </p>
                  <p>
                    <span className="font-semibold">Location:</span>{" "}
                    {category.store?.location || "Not specified"}
                  </p>
                </div>
                <div className="flex flex-col gap-2">
                  <button
                    className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition-colors"
                    onClick={() =>
                      navigate(
                        `${category.store.slug}/collections/${category.slug}`
                      )
                      
                    }
                  >
                    Explore Products
                  </button>
                  <button
                    className="w-full bg-gray-800 text-white py-2 rounded hover:bg-gray-900 transition-colors"
                    onClick={() =>
                      navigate(`/store/${category.store?.slug}`)
                    }
                  >
                    More Store Details
                  </button>
                  
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryList;
